import { useForm } from 'react-hook-form'

import { useFetchBarChartsMutation } from '@redux/api/barChart.api'

import { useHandlers } from '.'

export const useDiagrams = () => {
  const methods = useForm<{ searchPattern: string }>({ defaultValues: { searchPattern: '' } })
  const { watch } = methods
  const searchPattern = watch('searchPattern')

  const [fetchBarCharts, { isLoading: isLoadingDiagrams }] = useFetchBarChartsMutation()

  const { state, handlers } = useHandlers({ fetchBarCharts })

  return {
    state: {
      ...state,
      methods,
      isLoadingDiagrams,
    },
    handlers: {
      ...handlers,
    },
  }
}
